'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Spinner } from '@common/components';
import { SvgBookmark, SvgBookmarkFill, SvgNavigationArrowOn, SvgPhone, SvgShareLink } from '@common/icon';
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { AuthQueryOptions, BOOKMARK_TYPE } from '@/api';
import { openShareDrawer } from '@/app/_components/GlobalModal/_components/ShareDrawer';
import { IS_DEV } from '@/constants';
import { useBookmark } from '@/hooks/useBookmark';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { useLocation } from '@/hooks/useLocation';
import { CUSTOM_SCHEME } from '@/modules/wello-app';
import { useAuthStore } from '@/stores/AuthStore';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
interface ButtonListProps {
  title: string;
  tel: string;
  longitude: number;
  latitude: number;
  emergencyRoomId: number;
}
export const ButtonList = t0 => {
  const $ = _c(61);
  const {
    title,
    tel,
    latitude,
    longitude,
    emergencyRoomId
  } = t0;
  const {
    isWelloApp
  } = useCheckWelloApp();
  const isMobile = useDeviceInfoStore(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      enabledInitialFetch: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const location = useLocation(t1);
  const {
    bookmark
  } = useBookmark();
  const isLogin = useAuthStore(_temp2);
  let t2;
  if ($[1] !== emergencyRoomId) {
    t2 = AuthQueryOptions["get:/wello/v2/auth/emergency-room/{emergencyRoomId}"]({
      path: {
        emergencyRoomId
      }
    });
    $[1] = emergencyRoomId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isLogin || $[4] !== t2) {
    t3 = {
      ...t2,
      enabled: isLogin,
      select: _temp3
    };
    $[3] = isLogin;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: t4
  } = useQuery(t3);
  const isBookmarked = t4 === undefined ? false : t4;
  let t5;
  if ($[6] !== location.data?.longitude) {
    t5 = location.data?.longitude?.toString();
    $[6] = location.data?.longitude;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const fromLongitude = t5;
  let t6;
  if ($[8] !== location.data?.latitude) {
    t6 = location.data?.latitude?.toString();
    $[8] = location.data?.latitude;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const fromLatitude = t6;
  let t7;
  bb0: {
    if (!fromLongitude || !fromLatitude) {
      t7 = undefined;
      break bb0;
    }
    let navigationUrl;
    if ($[10] !== fromLatitude || $[11] !== fromLongitude || $[12] !== isMobile || $[13] !== latitude || $[14] !== longitude || $[15] !== title) {
      navigationUrl = new URL("http://map.naver.com");
      if (isMobile) {
        navigationUrl.pathname = navigationUrl.pathname + "/p/directions";
      } else {
        navigationUrl.pathname = navigationUrl.pathname + "/directions";
      }
      navigationUrl.searchParams.set("slng", fromLongitude);
      navigationUrl.searchParams.set("slat", fromLatitude);
      navigationUrl.searchParams.set("stext", "\uB0B4\uC704\uCE58");
      navigationUrl.searchParams.set("elng", longitude.toString());
      navigationUrl.searchParams.set("elat", latitude.toString());
      navigationUrl.searchParams.set("etext", title);
      navigationUrl.searchParams.set("menu", "route");
      $[10] = fromLatitude;
      $[11] = fromLongitude;
      $[12] = isMobile;
      $[13] = latitude;
      $[14] = longitude;
      $[15] = title;
      $[16] = navigationUrl;
    } else {
      navigationUrl = $[16];
    }
    let href = navigationUrl.href;
    if (isWelloApp) {
      href = CUSTOM_SCHEME.EXTERNAL_PREFIX + href;
    }
    t7 = href;
  }
  const navigationUrl_0 = t7;
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <li className="max-w-8 flex-1" />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== tel) {
    t9 = () => {
      window.location.href = `tel:${tel}`;
    };
    $[18] = tel;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SvgPhone className="size-20 text-Gray-700" />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t9) {
    t11 = <li><Button className="flex h-fit w-62 flex-col gap-8 whitespace-nowrap px-0 font-400 text-Gray-800 typo-body4" theme="primary-text" onClick={t9}>{t10}전화</Button></li>;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <li className="flex-1" />;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== fromLatitude || $[25] !== fromLongitude || $[26] !== isMobile || $[27] !== isWelloApp || $[28] !== latitude || $[29] !== longitude || $[30] !== navigationUrl_0 || $[31] !== title) {
    t13 = e => {
      if (!navigationUrl_0) {
        return e.preventDefault();
      }
      if (isMobile) {
        let href_0 = `nmap://route/public?slat=${fromLatitude}&slng=${fromLongitude}&dlat=${latitude}&dlng=${longitude}&dname=${title}`;
        if (isWelloApp) {
          href_0 = CUSTOM_SCHEME.EXTERNAL_PREFIX + href_0;
        }
        window.location.href = href_0;
      }
    };
    $[24] = fromLatitude;
    $[25] = fromLongitude;
    $[26] = isMobile;
    $[27] = isWelloApp;
    $[28] = latitude;
    $[29] = longitude;
    $[30] = navigationUrl_0;
    $[31] = title;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== navigationUrl_0) {
    t14 = navigationUrl_0 ? <SvgNavigationArrowOn className="size-20 text-Gray-700" /> : <Spinner size={20} />;
    $[33] = navigationUrl_0;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== navigationUrl_0 || $[36] !== t13 || $[37] !== t14) {
    t15 = <li><a className="flex h-fit w-62 flex-col gap-8 whitespace-nowrap px-0 font-400 text-Gray-800 flex-center typo-body4" href={navigationUrl_0} rel="noreferrer" target={IS_DEV ? "_self" : "_blank"} onClick={t13}>{t14}내비게이션</a></li>;
    $[35] = navigationUrl_0;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <li className="flex-1" />;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  const t17 = isBookmarked ? "text-B-500" : "text-Gray-800";
  let t18;
  if ($[40] !== t17) {
    t18 = cn("flex h-fit w-62 flex-col gap-8 whitespace-nowrap px-0 font-400 typo-body4", t17);
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  const t19 = isLogin && isBookmarked === undefined;
  let t20;
  if ($[42] !== bookmark || $[43] !== emergencyRoomId || $[44] !== isBookmarked || $[45] !== title) {
    t20 = () => bookmark({
      bookmarkType: BOOKMARK_TYPE.EMERGENCY_ROOM,
      contentId: emergencyRoomId,
      isBookmarked: isBookmarked ?? false,
      contentName: title
    });
    $[42] = bookmark;
    $[43] = emergencyRoomId;
    $[44] = isBookmarked;
    $[45] = title;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== isBookmarked) {
    t21 = isBookmarked ? <SvgBookmarkFill className="size-20 text-B-500" /> : <SvgBookmark className="size-20 text-Gray-700" />;
    $[47] = isBookmarked;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t18 || $[50] !== t19 || $[51] !== t20 || $[52] !== t21) {
    t22 = <li><Button className={t18} loading={t19} theme="primary-text" onClick={t20}>{t21}스크랩</Button></li>;
    $[49] = t18;
    $[50] = t19;
    $[51] = t20;
    $[52] = t21;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <li className="flex-1" />;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  let t25;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <li><Button className="flex h-fit w-62 flex-col gap-8 whitespace-nowrap px-0 font-400 text-Gray-800 typo-body4" theme="primary-text" onClick={_temp4}><SvgShareLink className="size-20 text-Gray-700" />공유</Button></li>;
    t25 = <li className="max-w-8 flex-1" />;
    $[55] = t24;
    $[56] = t25;
  } else {
    t24 = $[55];
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t11 || $[58] !== t15 || $[59] !== t22) {
    t26 = <ul className="flex items-center justify-between border-y border-Gray-200">{t8}{t11}{t12}{t15}{t16}{t22}{t23}{t24}{t25}</ul>;
    $[57] = t11;
    $[58] = t15;
    $[59] = t22;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  return t26;
};
function _temp(state) {
  return ["android", "ios"].includes(state.osType ?? "");
}
function _temp2(state_0) {
  return !!state_0.isLogin;
}
function _temp3(t0) {
  const {
    context
  } = t0;
  return context?.wishlistYN;
}
function _temp4() {
  openShareDrawer(window.location.href);
}